import accounts from './admin/accounts'
import affiliates from './admin/affiliates'
import affiliatePayments from './admin/affiliatePayments'
import audits from './admin/audits'
import meteredBillings from './admin/meteredBillings'
import quotes from './admin/quotes'
import braintreeSubscriptions from './admin/braintreeSubscriptions'
import pageviewDomains from './admin/pageviewDomains'
import paypalSubscriptions from './admin/paypalSubscriptions'
import profiles from './admin/profiles'
import stripeSubscriptions from './admin/stripeSubscriptions'
import subscriptions from './admin/subscriptions'
import licenses from './admin/licenses'
import kits from './admin/kits'
import tokens from './admin/tokens'

export default {
  namespaced: true,

  modules: {
    accounts,
    affiliates,
    affiliatePayments,
    audits,
    meteredBillings,
    quotes,
    braintreeSubscriptions,
    licenses,
    pageviewDomains,
    paypalSubscriptions,
    profiles,
    stripeSubscriptions,
    subscriptions,
    kits,
    tokens
  },

  mutations: {
    resetState(state) {
      // no-op
      return
    }
  }
}
